<script setup lang="ts">
import type { DialogLayer } from "./dialogStack";
import { provide } from "vue";
import { useDialogStack } from "../../composables/Dialog/useDialogStack";
import { DIALOG_LAYER_KEY } from "./dialogStack";

const { layer } = defineProps<{
  layer: DialogLayer
}>();

const stack = useDialogStack();

provide(DIALOG_LAYER_KEY, {
  get id() {
    return layer.id;
  },
  get instanceId() {
    return layer.instanceId;
  },
  get paddingless() {
    return layer.paddingless;
  },
  close: () => stack.pop(layer.instanceId),
  closeAfterSave: () => stack.popAfterSave(layer.instanceId),
  setDirty: (dirty: boolean) => stack.setDirty(layer.instanceId, dirty),
  setDirtyFieldLabels: fn => stack.setDirtyFieldLabels(layer.instanceId, fn),
  setLocked: (locked: boolean) => stack.setLocked(layer.instanceId, locked),
  setOnLocked: fn => stack.setOnLocked(layer.instanceId, fn),
});
</script>

<template>
  <slot />
</template>
